import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags'; 
import { Link } from 'react-router-dom'; // Added Meta Tag npm Package
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, UncontrolledTooltip, Badge } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import { Config, TOAST_OPTIONS } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Select from 'react-select';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import { Button} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'

    const Suppliers = () => {

        toastr.options = TOAST_OPTIONS;

        const [modal_suppliers, setmodal_suppliers] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [supplierList, setSupplierList] = useState([]);
        const [isloading, setIsloading] = useState(false)
        

        const [id, setId] = useState('')
        const [name, setName] = useState('')
        const [code, setCode] = useState('')
        const [address, setAddress] = useState('')
        const [phone, setPhone] = useState('')
        const [email, setEmail] = useState('')
        const [status, setStatus] = useState('')
        const [userId, setUserId] = useState('')
        const [selectedCategories, setSelectedCategories] = useState(null)
        const [supplierCategoryOptions, setSupplierCategoryOptions] = useState([]);

        const [sId, setSId] = useState('')
        const [sName, setSName] = useState('')
        const [sPhone, setSPhone] = useState('')
        const [sCategory, setSCategory] = useState('')
        const [sCode, setSCode] = useState('')


        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_suppliers = () => {
          setmodal_suppliers(!modal_suppliers);
          removeBodyCss();
        }

        const handleFilterData = () =>{
            const data = {
                name    : sName, 
                code    : sCode, 
                phone   : sPhone, 
                category: sCategory
            }
            setIsloading(true)
            axios.post(url.SUPPLIERFILTER, JSON.stringify(data), Config).then((r)=>{ 
                setSupplierList(r.data)
              }).catch((e)=>{  
                console.log(e); 
              }).finally(()=>{
                setIsloading(false)
              })
         
        }
        useEffect(() => {
            axios.get(url.SUPPLIERCATEGORIES, Config).then((r)=>{
                let arr = []
                if(r.data){
                    r.data.map((m)=>{
                        arr.push({value:m.name, label:m.name})
                    })
                    setSupplierCategoryOptions(arr)
                }
            }).catch((e)=>{
                console.log(e)
            })
            if(localStorage.getItem("authWTUser")){
                const obj = JSON.parse(localStorage.getItem("authWTUser"));
                setUserId(obj.id)
            } 
            handleFilterData()
        },[]);

        const handleClickEdit = (row) => {
          setIsEdit(true)
          tog_suppliers()
          setId(row.id)
          setName(row.name)
          setCode(row.code)
          setAddress(row.address)
          setPhone(row.phone)
          setEmail(row.email)
          setStatus(row.status)
          const selectedArray = row.category.split(', ').map((category) =>
            supplierCategoryOptions.find((option) => option.label === category)
          );
          setSelectedCategories(selectedArray);
        }
        const handleChange = (selectedOptions) => {
            setSelectedCategories(selectedOptions);
        };
        const handleClickAdd = () => {  
          setIsEdit(false);
          tog_suppliers();  
        }
        const handleSaveSupplier = () =>{
            const data = {
                id      : isEdit?id:'',
                name    : name,
                code    : code,
                address : address,
                phone   : phone,
                email   : email,
                status  : status,
                category: selectedCategories.map(option => option.value).join(', '),
                action  : isEdit?'edit':'add'
            }
            setIsloading(true)
            axios.post(url.SUPPLIERS, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == '1'){
                    toastr.success(r.data.message)
                    setName('')
                    setCode('')
                    setAddress('')
                    setPhone('')
                    setPhone('')
                    setEmail('')
                    setStatus('')
                    setIsEdit(false)
                    tog_suppliers()
                    handleFilterData()
                }else{
                    toastr.error(r.data.message)
                }
            }).catch((e)=>{
                console.log(e)
            }).finally(()=>{
                setIsloading(false)
            })
        }

        const columns = [

        {
          dataField: 'name',
          text: 'Name',
          sort: true
        },
        {
          dataField: 'phone',
          text: 'phone',
          sort: true
        },
        {
          dataField: 'category',
          text: 'Category',
          sort: true
        },
        {
          dataField: 'lastSupplyDate',
          text: 'Last Supply Date',
          sort: true
        },
        {
          dataField: 'status',
          text: 'Status',
          sort: true,
          formatter: statusFormatter 
        },
        {
          dataField: "",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'id',
          order: 'asc'
        }];
        function statusFormatter(cellContent, row) {
          if (row.status == "Active") {
            return (
              <div>
                  <Badge className="me-2 bg-success">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-danger">
                  { cellContent }
                  </Badge>
              </div>
            );
          }
        }
        function actionFormatter(cellContent, row){
          return(
            <>
            <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  onClick={() => { handleClickEdit(row); }}
                >
                  Details
            </Button>
          </>
          )
        }

        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Suppliers and Contractors| {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title={url.COMPANY} breadcrumbItem="Suppliers and Contractors" />
                        <Row>
                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                                <CardBody>
                                    <Row className="justify-content-center mb-1">
                                                <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Search by Name</label>
                                                          <input type='text' className="form-control form-control-sm" value={sName} onChange={(e)=>setSName(e.target.value)} />
                                                      </div>
                                                  </Col>
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Code</label>
                                                          <input type='text' className="form-control form-control-sm" value={sCode} onChange={(e)=>setSCode(e.target.value)} />
                                                      </div>
                                                  </Col>
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Phone</label>
                                                          <input type='text' className="form-control form-control-sm" value={sPhone} onChange={(e)=>setSPhone(e.target.value)} />
                                                      </div>
                                                  </Col>
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Category</label>
                                                          <input type='text' className="form-control form-control-sm" value={sCategory} onChange={(e)=>setSCategory(e.target.value)} />
                                                      </div>
                                                  </Col>
                                                </Row>
                                       
                                                <Row  className="justify-content-center mb-2 mt-3">
                                                <Col lg={2}> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                 
                                                  <Col lg={2}> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClickAdd()}}
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Add Company
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  
                                                </Row>
                                                </CardBody>
                                                </Card>
                        
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Companies ({supplierList.length})</h5>
                                <CardBody>

                                
                                <Modal isOpen={modal_suppliers} toggle={() => { tog_suppliers();}} centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit ? 'Edit Supplier ': 'Add Company' }</h5>
                                    <button onClick={() => { setmodal_suppliers(false);}} className="close" data-dismiss="modal" aria-label="Close"></button>
                                  </div>
                                  <div className="modal-body">
                                    <Row>
                                        <Col xl={6}>
                                            <div className="mb-3">
                                                <label>Name</label>
                                                <input type="text" className="form-control" value={name} onChange={(e)=>setName(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col xl={6}>
                                            <div className="mb-3">
                                                <label>Code</label>
                                                <input type="text" className="form-control" value={code} onChange={(e)=>setCode(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col xl={6}>
                                            <div className="mb-3">
                                                <label>Address</label>
                                                <input type="text" className="form-control" value={address} onChange={(e)=>setAddress(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col xl={6}>
                                            <div className="mb-3">
                                                <label>Phone</label>
                                                <input type="text" className="form-control" value={phone} onChange={(e)=>setPhone(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col xl={6}>
                                            <div className="mb-3">
                                                <label>E-mail</label>
                                                <input type="text" className="form-control" value={email} onChange={(e)=>setEmail(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                        <div className="mb-3">
                                            <label>Status</label>
                                            <select className="form-select" value={status} onChange={(e)=>setStatus(e.target.value)}>
                                                <option value=""></option>
                                                <option value="Active">Active</option>
                                                <option value="Disabled">Disabled</option>
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Category</label>
                                            <Select 
                                                options={supplierCategoryOptions}
                                                isMulti
                                                value={selectedCategories}
                                                onChange={handleChange}
                                                placeholder="Select supplier categories..."
                                                className="basic-multi-select"
                                                classNamePrefix="select"/>
                                        </div>
                                    </Col>
                                    </Row>
                                  </div>
                                  
                                  <div className="modal-footer">
                                    {isloading?`Please wait...`:(<>
                                    <button  onClick={() => { tog_suppliers(); }} className="btn btn-danger" data-dismiss="modal">Close</button>
                                    <button className="btn btn-success" onClick={handleSaveSupplier}>Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                {supplierList && (supplierList.length > 0) && (
                                    <>
                                    <ToolkitProvider
                                      keyField="id"
                                      data={supplierList}
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={supplierList} 
                                                  columns={ columns } 
                                                  striped
                                                  //hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>

                                    </>
                                )}
                                {supplierList && (supplierList.length < 1) && (
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                        </div>
                                        <div>
                                        <h5>No company found</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>

                                )}
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default Suppliers;